import { useLiveStreamAppContext } from "../ContextStore/Store";

const Permission = () => {
  const { 
    setMicrophonePermission,
    setCameraPermission
   } = useLiveStreamAppContext();

  //this is virtual click function which work on the basis of the Data Messaging
  async function checkPermissions() {
    // Safari < 16 has no Permissions API - PermissionsFetch sets the state from getUserMedia instead
    if (!navigator.permissions?.query) return;
    try {
        // Check microphone permission
        const micPermission = await navigator.permissions.query({ name: 'microphone' });
        setMicrophonePermission(micPermission.state);
        
        micPermission.onchange = () => {
          setMicrophonePermission(micPermission.state);
        };
  
        // Check camera permission
        const cameraPermission = await navigator.permissions.query({ name: 'camera' });
        setCameraPermission(cameraPermission.state);
        
        cameraPermission.onchange = () => {
          setCameraPermission(cameraPermission.state);
        };
      } catch (error) {
        console.error('Permission API error:', error);
      }
  }
  return { checkPermissions };
};

export default Permission;
